// material-ui
import { Theme, useTheme } from "@mui/material/styles";
import ButtonBase, { ButtonBaseProps } from "@mui/material/ButtonBase";

// assets
import BUTTON_BG from "assets/images/button/bg.png";

// ==============================|| BUTTON ||============================== //

const BUTTON_SCENE = {
  LOGIN: BUTTON_BG,
  CALCULATE: BUTTON_BG,
  BUY: BUTTON_BG
};
interface ButtonProps extends ButtonBaseProps {
  scene: "LOGIN" | "CALCULATE" | "BUY";
  children: JSX.Element | string;
}

const Button = ({ scene, children, sx, onClick }: ButtonProps): JSX.Element => {
  const theme: Theme = useTheme();

  return (
    <ButtonBase
      sx={{
        width: "100%",
        height: 45,
        // borderRadius: { xs: 2, sm: 4 },
        background: `no-repeat center url(${BUTTON_SCENE[scene]})`,
        backgroundSize: "100% 100%",
        ...theme.typography.subtitle2,
        ...sx
      }}
      onClick={onClick}
    >
      {children}
    </ButtonBase>
  );
};

export default Button;
